import React from 'react';

import {
	ConnectionsByLineMenu,
	type ConnectionsByLineMenuProps,
} from './ConnectionsByLineMenu.tsx';
import { EmbeddedConnectionsByLineMenu } from './EmbeddedConnectionsByLineMenu.tsx';
import { MAX_BYLINE_CONNECTION_ICONS } from './utils/getBylineConnectionIcons.ts';

export type BylineConnectionsMenuContentProps = Omit<
	ConnectionsByLineMenuProps,
	'minIcons' | 'showFooter'
> & {
	isEmbeddedMenu: boolean;
};

/** Maps each menu's supported inputs without exposing panel actions to embedded views. */
export const BylineConnectionsMenuContent = ({
	isEmbeddedMenu,
	...props
}: BylineConnectionsMenuContentProps): React.JSX.Element =>
	isEmbeddedMenu ? (
		<EmbeddedConnectionsByLineMenu
			links={props.links}
			relatedContentLinks={props.relatedContentLinks}
			relatedContentLoading={props.relatedContentLoading}
			refreshLinkUrl={props.refreshLinkUrl}
			onNavigate={props.onNavigate}
		/>
	) : (
		<ConnectionsByLineMenu
			{...props}
			minIcons={MAX_BYLINE_CONNECTION_ICONS}
			showFooter={(props.links?.length ?? 0) > 0}
		/>
	);
